<template>

    <bottom-sheet ref="bottomsheet"
                  :maxWidth="false"
                  :extraSize="bigScreenWidth">


        <div class="bsdcc">

            <div>

                <img src="/img/discovery/mailbox-empty.svg" class="img__72" v-show="isBigScreen">

                <p class="text-xlBold">{{ $t('connect_your_mailbox') }}</p>

                <p class="text-lMedium color__moon mt__8">{{ $t('discover_all_features') }}</p>

                <carousel-discovery class="mt__24"></carousel-discovery>

            </div>

            <div class="actions">

                <button class="cta-medium-primary" @click="goLogin">{{ $t('connect_my_mailbox') }}</button>

                <div v-show="isBigScreen" class="mr__6 ml__6"></div>

                <button @click="continueDiscovery" :class="{'cta-small-dropdown-simple mt__8': !isBigScreen, 'cta-medium-tertiary': isBigScreen}">{{ $t('continue_dicovery_mode') }}</button>

            </div>

        </div>

    </bottom-sheet>

</template>

<script>
import Vuex from 'vuex'

import Tag from '../../modules/tag'

import BottomSheet from '../../components/bottomSheet/BottomSheet'
import CarouselDiscovery from '../../components/discovery/carousel'

export default {

    name: 'bottom-sheet-discovery-connect-or-continue',

    components: {
        BottomSheet,
        CarouselDiscovery
    },

    computed: {
        ...Vuex.mapGetters([
            'innerWidth'
        ]),

        isBigScreen() {
            return this.innerWidth > this.bigScreenWidth
        }
    },

    data() {
        return {
            bigScreenWidth: 1090
        }
    },

    methods: {

        open() {
            Tag.pageViewAll(this, 'demo_mode_exit_suggestion')
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        },

        goLogin() {
            Tag.clickAll(this, 'connect_mailbox')
            this.$router.push({ path: '/login/email' })
        },

        continueDiscovery() {
            Tag.clickAll(this, 'continue_demo')
            this.close()
        }
    }
}

</script>

<style lang="scss" scoped>

.bsdcc {
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: space-between;
    @media screen and (min-width: $above-tablet-length) {
        padding: 48px 25px 60px;
    }

    .actions {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 16px 0;
        @media screen and (min-width: $above-tablet-length) {
            padding: 40px 0 0;
            flex-direction: row-reverse;
            justify-content: center;
        }
    }

}

</style>
